import _ from "lodash";

export const tools = {
  makeCapitalCase: (s) => {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.toLowerCase().slice(1);
  },
  toLowerCase: (s) => {
    if (typeof s !== "string") return "";
    return s.toLowerCase();
  },
  parseBool: (str) => {
    let val = false;
    if (typeof str === "string") {
      if (str.trim().toLowerCase() === "true") {
        val = true;
      } else if (str.trim().toLowerCase() === "false") {
        val = false;
      }
      return val;
    } else {
      return str;
    }
  },
  justNumber: (str) => {
    let result = str.replace(/[^\d]/g, "");
    return result;
  },

  justEnglish: (value) => {
    return `${value}`.replace(/[^a-zA-Z\s]/g, "");
  },

  isObject: (data) => {
    return data && typeof data === "object";
  },

  toObject(data) {
    return this.isObject(data) ? data : {};
  },

  isArray: (data) => {
    return data && typeof data === "object" && data.constructor === Array;
  },
  toArray(data) {
    return this.isArray(data) ? data : [];
  },
  arrayPad: (arr, len, fill) => {
    return arr.concat(Array(len).fill(fill)).slice(0, len);
  },

  jsonDecode: (json) => {
    try {
      return JSON.parse(json);
    } catch (e) {
      console.log(e);
      return null;
    }
  },

  previewFile: (fileBlob, callback = () => {}) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      callback(reader.result);
    };
    reader.readAsDataURL(fileBlob);
  },

  joinDurationObject: (duration) => {
    const { hours, minutes, seconds } = duration || {};
    const array = [];
    if (hours) {
      array.push(`${hours} hours`);
    }
    if (minutes) {
      array.push(`${minutes} minutes`);
    }
    if (seconds) {
      array.push(`${seconds} seconds`);
    }

    return array.join(" : ");
  },

  /**
   * Find specific field error message from errorArray
   * @param {{field: String, errorMessage: String}[]} errorArray
   * @param {string} fieldName the field's name that you want to look for into errorArray
   * @return {string} field error message if found. otherwise return empty string
   */
  findErrorMessage: (errorArray, fieldName) => {
    const t = errorArray.find((x) => x.field === fieldName);
    if (t) {
      return t.errorMessage;
    } else {
      return "";
    }
  },
  /**
   * Get Validation model, and input data object then return result array that we can store it into errors Array. if there is no error, it will be empty
   * @param {Schema} validationModelSchema
   * @param {Object} inputObject object of values that contain field's name for each input
   * @return {{field: String, errorMessage: String}[]}
   */
  applyModelCheckValidation: (validationModelSchema, inputObject) => {
    let result = [];
    const checkResult = validationModelSchema.check(inputObject);
    for (let key in checkResult) {
      let value = checkResult[key];
      if (value.hasError) {
        result.push({ field: key, errorMessage: value.errorMessage });
      }
    }
    return result;
  },

  //گروه بندی دیتا ورودی از ای پی آی  ورودی ها دیتا برگشته از ای پی ای و کی هم نام فیلد برای گروه بندی برحسب رشته
  groupByListBasketItem: (array, key) => {
    return array.reduce((result, currentValue) => {
      (result[currentValue[key]] = result[currentValue[key]] || []).push(
        currentValue
      );
      return result;
    }, {});
  },

  setPageNumber: (data, oldSearchParams, setValue) => {
    Object.entries(data).every((item) => {
      let [key, value] = item;
      if (
        ["pageNumber", "pageSize", "totalPages", "totalCount"].includes(key)
      ) {
        return true; // it means continue the loop
      }
      // console.log("key", key, oldSearchParams.get(key))
      // console.log("isEmpty", key, _.isEmpty(oldSearchParams.get(key)))
      // console.log("isEmpty value", value, _.isEmpty(value))

      value = _.isNumber(value) ? _.toString(value) : value;

      if (!_.isEmpty(oldSearchParams.get(key))) {
        if (_.isArray(value)) {
          let oldSearchParamsArray = oldSearchParams
            .get(key)
            .split(",")
            .map((i) => Number(i));
          let convertedValue = value.map((item) =>
            typeof item == "string"
              ? item.split(",").map((i) => Number(i))
              : item
          );

          if (!_.isEqual(oldSearchParamsArray, convertedValue.flat(1))) {
            data.pageNumber = 1;
            setValue("pageNumber", 1);
          }
        } else if (value != oldSearchParams.get(key)) {
          data.pageNumber = 1;
          setValue("pageNumber", 1);
        }
      } else if (!_.isEmpty(value)) {
        data.pageNumber = 1;
        setValue("pageNumber", 1);
      }

      return true;
    });
  },
  createQueryStringFromFromData: (data) => {
    let queryString = "";
    Object.entries(data).forEach(([key, value], index) => {
      const isEmptyArray = _.isArray(value) ? _.isEmpty(value) : false;
      if (value !== undefined && value !== "" && !isEmptyArray) {
        if (Array.isArray(value)) {
          queryString += `${key}=${value.join(",")}`;
        } else {
          queryString += `${key}=${value}`;
        }
        if (index >= 0) {
          queryString += "&";
        }
      }
    });
    return queryString;
  },

  setInputsValues_ReactHookFrom: (setValue, formValues, formInputs) => {
    (async () => {
      try {
        formValues.forEach((value, key) => {
          const foundObject = formInputs.find((obj) => obj.name === key);
          if (foundObject) {
            switch (foundObject.type) {
              case "text":
                {
                  setValue(`${key}`, `${value}`);
                }
                break;
              case "datePicker":
                var splitValueFromUrl = `${value}`.split("/");
                if (splitValueFromUrl.length > 2) {
                  const value = {
                    year: splitValueFromUrl[0],
                    month: splitValueFromUrl[1],
                    day: splitValueFromUrl[2],
                  };
                  setValue(
                    `${key}`,
                    `${value.year}/${("0" + value.month).slice(-2)}/${("0" + value.day).slice(-2)}`
                  );
                }
                break;
                case "multiSelect": {
                  const splitValueFromUrl = `${value}`.split(",");
                  // فیلتر کردن آرایه براساس مقادیر جدا شده
                  const valueList = foundObject.data
                    .filter((item) => splitValueFromUrl.includes(item.id.toString()))
                      .map((obj) => {
                       // اگر فیلد name در آبجکت وجود دارد، آن را به title تغییر دهید
                      if (obj.hasOwnProperty("name")) {
                        return { ...obj, title: obj.name, name: undefined };
                      }
                      return obj;
                    });
                
                  // اگر isMulti ست نشده بود، پیش‌فرض true در نظر بگیر
                  const isMulti = foundObject.isMulti ?? true;
                
                  if (isMulti) {
                    setValue(`${key}`, valueList.map((item) => ({
                      value: item.id,
                      label: item.title,
                      labelId: item.id,
                    })));
                  } else {
                    const selected = valueList.length > 0 ? valueList[0] : null;
                    setValue(`${key}`, selected ? {
                      value: selected.id,
                      label: selected.title,
                      labelId: selected.id,
                    } : null);
                  }
                }
                break;
                case 'multiSelectInGroup': {
                  const splitValueFromUrl = `${value}`.split(',');
    
                  // data باید به صورت آرایه‌ای از گروه‌ها با کلید options باشد
                  const flatOptions = foundObject.data
                    ?.flatMap(group => group.options) || [];
    
                  const values = flatOptions
                    .filter(item => splitValueFromUrl.includes(item.value?.toString()))
                    .map(item => ({
                      value: item.value,
                      label: item.label,
                      labelId: item.value,
                    }));
                  setValue(`${key}`, values);
                  break;
                }
                break;
              case "number":
                var value = !_.isEmpty(`${value}`) ? _.toNumber(`${value}`) : 1;
                setValue(`${key}`, value);
              default:
            }
          }
        });
      } catch (error) {
      } finally {
      }
    })();
  },

  getShamsiDateIntlEnglishNumbers: () => {
    // Create a new date instance for today
    const today = new Date();

    // Use Intl.DateTimeFormat with the "fa-IR" locale and "persian" calendar
    const formatter = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    // Format the date
    const formattedDate = formatter.format(today);

    // Replace Persian numbers with English numbers
    const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    const englishNumbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

    const englishDate = formattedDate.replace(
      /[۰-۹]/g,
      (match) => englishNumbers[persianNumbers.indexOf(match)]
    );

    return englishDate;
  },

  handleResetAdvanceSearchBox: (watch, reset) => {
    // ریست کردن همه فیلد ها در ریکت هوک فرم به جز موارد پایین در آرایه
    const excludedFieldsArray = [
      "pageNumber",
      "pageSize",
      "globalSearch",
      "totalCount",
      "totalPages",
    ];
    const formFieldStates = { ...watch() };
    const excludedFields = {};
    Object.entries(formFieldStates).forEach((item) => {
      const [key, value] = item;
      if (excludedFieldsArray.includes(key)) {
        excludedFields[key] = value;
      }
    });
    reset({ ...excludedFields });
  },
  formatPriceNumber: (value) => {
    const stringValue = String(value);
    return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  DateFormat: (date) => {
    if (date) {
      var newDate = `${date.year}/${("0" + date.month).slice(-2)}/${("0" + date.day).slice(-2)}`;
      return newDate;
    }
    else
      return "";
  },
};
